import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const API_URL = process.env.REACT_APP_API_URL;

// Super-admin: list all global print items
const getAllPrintItems = () => {
    return axios
        .get(API_URL + "/admin/printitems", { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Super-admin: get a single print item by id
const getPrintItemById = (id) => {
    return axios
        .get(API_URL + "/admin/printitems/" + id, { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Public: get a single print item by id (only if in current subsite's catalog)
const getPublicPrintItemById = (id) => {
    return axios
        .get(API_URL + "/printitems/" + id, { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Super-admin: create a print item (FormData with files)
const createPrintItem = (formData) => {
    const headers = { ...AuthHeader.authHeader(), 'Content-Type': 'multipart/form-data' };
    return axios
        .post(API_URL + "/admin/printitems", formData, { headers, timeout: 10 * 60 * 1000 })
        .then((response) => response.data);
};

// Super-admin: update a print item (FormData with files)
const updatePrintItem = (id, formData) => {
    const headers = { ...AuthHeader.authHeader(), 'Content-Type': 'multipart/form-data' };
    return axios
        .put(API_URL + "/admin/printitems/" + id, formData, { headers, timeout: 10 * 60 * 1000 })
        .then((response) => response.data);
};

// Super-admin: delete a print item
const deletePrintItem = (id) => {
    return axios
        .delete(API_URL + "/admin/printitems/" + id, { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Super-admin: delete a single additional image
const deletePrintItemImage = (printItemId, imageId) => {
    return axios
        .delete(API_URL + "/admin/printitems/" + printItemId + "/images/" + imageId, { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Super-admin: delete a single print-ready artwork
const deletePrintItemArtwork = (printItemId, artworkId) => {
    return axios
        .delete(API_URL + "/admin/printitems/" + printItemId + "/artworks/" + artworkId, { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Site-admin: list all print items with inCatalog flag for current subsite
const getPrintItemsForSubsiteCatalog = () => {
    return axios
        .get(API_URL + "/admin/catalog/printitems", { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Public/user: get only the print items in the current subsite's catalog
const getSubsitePrintItemCatalog = () => {
    return axios
        .get(API_URL + "/catalog/printitems", { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Site-admin: add a global print item to the current subsite's catalog
const addPrintItemToCatalog = (printItemId) => {
    return axios
        .post(API_URL + "/admin/catalog/printitems", { printItemId }, { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

// Site-admin: remove a print item from the current subsite's catalog
const removePrintItemFromCatalog = (printItemId) => {
    return axios
        .delete(API_URL + "/admin/catalog/printitems/" + printItemId, { headers: AuthHeader.authHeader() })
        .then((response) => response.data);
};

const PrintItemService = {
    getAllPrintItems,
    getPrintItemById,
    getPublicPrintItemById,
    createPrintItem,
    updatePrintItem,
    deletePrintItem,
    deletePrintItemImage,
    deletePrintItemArtwork,
    getPrintItemsForSubsiteCatalog,
    getSubsitePrintItemCatalog,
    addPrintItemToCatalog,
    removePrintItemFromCatalog,
};

export default PrintItemService;
